// Field definitions for the declarative protocol analyzers built in
// 00117-starek-324-nwm's main/analyzers/ (analyzer_json.cpp parses these
// exact key names off a signal's "analyzer" object) - shared, plain-data
// module so DeviceEditSidebar.jsx (Tailwind) and AddDeviceProfileWizard.jsx
// (Bootstrap) can each render their own styled form from the same schema
// instead of forcing one shared component across two different CSS
// approaches.

export const ANALYZER_KINDS = [
    { value: "fixed_width_field", label: "Fixed-width field" },
    { value: "delimited_frame", label: "Delimited frame" },
    { value: "modbus_rtu", label: "Modbus RTU" },
];

const FIXED_WIDTH_FIELDS = [
    { name: "offset", label: "Offset (bytes)", type: "number", default: 0 },
    { name: "width", label: "Width (bytes)", type: "number", default: 2 },
    {
        name: "byte_order",
        label: "Byte order",
        type: "select",
        options: [
            { value: "big", label: "Big-endian" },
            { value: "little", label: "Little-endian" },
        ],
        // Little-endian by default - matches how firmware feeds a raw
        // internal scalar (GPIO/virt acquisition: readAnalogSignal's
        // average, queueDigitalReading's scaled level, /virt/wifi_rssi's
        // computed value) as a native uint16_t on Xtensa, same as the six
        // built-in default logical signals hardcode
        // (setupDefaultLogicalSignals() -> LITTLE_ENDIAN_ORDER). Only a
        // genuinely big-endian external wire protocol (some I2C sensors)
        // needs this flipped - "big" silently misdecodes any GPIO/virt
        // source (e.g. reads 1023 as 65283 - confirmed live).
        default: "little",
    },
    { name: "scale", label: "Scale", type: "number", default: 1 },
    { name: "bias", label: "Bias", type: "number", default: 0 },
];

export const ANALYZER_KIND_FIELDS = {
    fixed_width_field: FIXED_WIDTH_FIELDS,
    delimited_frame: [
        { name: "start_delimiter", label: "Start delimiter (byte value)", type: "number", default: 36 },
        { name: "end_delimiter", label: "End delimiter (byte value)", type: "number", default: 10 },
        { name: "fixed_length", label: "Fixed length (used if no end delimiter)", type: "number", default: 0 },
        ...FIXED_WIDTH_FIELDS,
    ],
    modbus_rtu: [
        { name: "slave_id", label: "Slave ID", type: "number", default: 1 },
        { name: "function_code", label: "Function code", type: "number", default: 3 },
        { name: "register_address", label: "Register address", type: "number", default: 0 },
        { name: "register_count", label: "Register count", type: "number", default: 1 },
        { name: "scale", label: "Scale", type: "number", default: 1 },
        { name: "bias", label: "Bias", type: "number", default: 0 },
    ],
};

export function defaultAnalyzerConfig(kind) {
    const fields = ANALYZER_KIND_FIELDS[kind] || [];
    return fields.reduce((acc, f) => ({ ...acc, [f.name]: f.default }), { kind });
}
